export default __webpack_public_path__ + "static/media/attraction1.53e91411.jpg";